module.exports = __webpack_public_path__ + "scti-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/scti-logo.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/scti-logo.png
// module chunks = 12